var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 51.8502C16.4925 38.552 18.4642 30.2608 24.3622 24.3627C30.2603 18.4647 38.5515 16.493 51.8497 15.834M136.167 51.8502C135.508 38.552 133.536 30.2608 127.638 24.3627C121.74 18.4647 113.449 16.493 100.15 15.834M100.15 136.167C113.449 135.508 121.74 133.536 127.638 127.639C133.536 121.74 135.508 113.449 136.167 100.151M51.8496 136.167C38.5515 135.508 30.2603 133.536 24.3622 127.639C18.4642 121.74 16.4925 113.449 15.8335 100.151",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 51.8502C16.4925 38.552 18.4642 30.2608 24.3622 24.3627C30.2603 18.4647 38.5515 16.493 51.8497 15.834M136.167 51.8502C135.508 38.552 133.536 30.2608 127.638 24.3627C121.74 18.4647 113.449 16.493 100.15 15.834M100.15 136.167C113.449 135.508 121.74 133.536 127.638 127.639C133.536 121.74 135.508 113.449 136.167 100.151M51.8496 136.167C38.5515 135.508 30.2603 133.536 24.3622 127.639C18.4642 121.74 16.4925 113.449 15.8335 100.151",
    stroke: "url(#paint0_linear_16725_952)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1666 66.845C60.1666 61.5143 59.3294 53.2846 62.5481 48.4859C69.6571 37.887 84.74 39.2949 90.06 49.6404C92.6712 54.7179 91.687 61.8167 91.808 66.845M60.1666 66.845C51.9502 66.845 50.2767 71.5488 49.0201 75.238C47.8602 79.3882 46.6793 89.298 48.4881 100.156C49.8413 107.074 55.1303 110.116 59.6788 110.502C64.0287 110.871 82.3947 110.73 87.7116 110.73C95.9506 110.73 101.095 108.919 103.512 100.618C104.672 94.1614 104.99 82.6163 103.056 75.238C100.495 67.859 95.3312 66.845 91.808 66.845M60.1666 66.845C68.8661 66.4999 86.8344 66.5683 91.808 66.845",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1666 66.845C60.1666 61.5143 59.3294 53.2846 62.5481 48.4859C69.6571 37.887 84.74 39.2949 90.06 49.6404C92.6712 54.7179 91.687 61.8167 91.808 66.845M60.1666 66.845C51.9502 66.845 50.2767 71.5488 49.0201 75.238C47.8602 79.3882 46.6793 89.298 48.4881 100.156C49.8413 107.074 55.1303 110.116 59.6788 110.502C64.0287 110.871 82.3947 110.73 87.7116 110.73C95.9506 110.73 101.095 108.919 103.512 100.618C104.672 94.1614 104.99 82.6163 103.056 75.238C100.495 67.859 95.3312 66.845 91.808 66.845M60.1666 66.845C68.8661 66.4999 86.8344 66.5683 91.808 66.845",
    stroke: "url(#paint1_linear_16725_952)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16725_952",
    x1: 15.8335,
    y1: 15.834,
    x2: 158.838,
    y2: 56.5611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16725_952",
    x1: 47.5557,
    y1: 41.1797,
    x2: 116.887,
    y2: 57.3243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocker);
export default __webpack_public_path__ + "static/media/locker.007bd03dbaae3cabe38cc00f7532b15b.svg";
export { ForwardRef as ReactComponent };